import { BehaviorSubject } from 'rxjs';
var TalentScansFilter = /** @class */ (function () {
    function TalentScansFilter() {
        this.workValues = [];
        this.teamRoles = [];
        this.domains = [];
    }
    Object.defineProperty(TalentScansFilter.prototype, "workValueIds", {
        get: function () {
            return this.workValues.length > 0 ? this.workValues.join(',') : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TalentScansFilter.prototype, "teamRoleIds", {
        get: function () {
            return this.teamRoles.length > 0 ? this.teamRoles.join(',') : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TalentScansFilter.prototype, "domainIds", {
        get: function () {
            return this.domains.length > 0 ? this.domains.join(',') : undefined;
        },
        enumerable: true,
        configurable: true
    });
    return TalentScansFilter;
}());
export { TalentScansFilter };
var TalentScansFilterService = /** @class */ (function () {
    function TalentScansFilterService() {
        this.filter$ = new BehaviorSubject(new TalentScansFilter());
    }
    return TalentScansFilterService;
}());
export { TalentScansFilterService };
